import Vue from 'vue';
import VueRouter from 'vue-router';
import Location from '../views/Location.vue';

import Home from '../views/Home.vue';
// const Location = () => import(/* webpackChunkName: "locationComponent" */ '../views/Location.vue');
Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: 'Home',
    component: Home,
  },
  // {
  //   path: '/locations/search/:query',
  //   name: 'Home',
  //   component: Home,
  // },
  {
    path: '/locations/details/:slug',
    name: 'LocationPage',
    component: Location,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
